import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteComment } from "./comments.service";
import { invalidateTaskQueries } from "./queryKeyHelper";

type DeleteCommentInput = {
  taskId: string;
  commentId: string;
};

export const useDeleteComment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ commentId }: DeleteCommentInput) => deleteComment(commentId),
    onSuccess: () => {
      return invalidateTaskQueries(queryClient);
    },
  });
};
